import React, { useEffect, useState } from "react";
import {
  getAuth,
  signInWithEmailLink,
  isSignInWithEmailLink,
  EmailAuthProvider,
  GoogleAuthProvider,
} from "firebase/auth";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import superSignLogo from "../../../assets/icons/supersign-logo.png";
import { Rings } from "react-loader-spinner";
import { auth } from "../../../firebaseConfig";
import useUserAuthenticatedStore from "../../workspace-plugin/zustand/useUserAuthenticatedStore";
import VerifyEmailDialog from "../components/dialog/verify-email.dialog";
import AuthenticationService from "../../profile-plugin/services/authentication-service";
import useMembersManagement from "../../workspace-plugin/hooks/useMembersManagement";

const FirebaseAuth = () => {
  const {acceptInvite} = useMembersManagement();


  const storedInvitationDetails = JSON.parse(localStorage.getItem("invitationDetails"));

  const { setUserAuthenticated } = useUserAuthenticatedStore();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const authInstance = getAuth();

  const url = window.location.href;

  const isMobile = useMediaQuery('(max-width:600px)');

  const [email, setEmail] = useState("");
  const [isDialogOpen, setDialogOpen] = useState(false);


  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    const handlePopState = () => {
      if (window.location.pathname === "/login") {
        navigate("/");
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  const handleAcceptInvitation = () => {
    const formData = new FormData();
            
    formData.append("invitation_code", storedInvitationDetails?.invitation?.code);
    acceptInvite(formData, storedInvitationDetails?.workspace?.id);
  } 

  useEffect(() => {

    const uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: (authResult) => {
          console.log("login authResult xxxx", authResult, authResult.additionalUserInfo, authResult.additionalUserInfo.providerId === EmailAuthProvider.PROVIDER_ID);
 
          const user = authResult.user;
          setUserAuthenticated(user);

          if (storedInvitationDetails) {
            handleAcceptInvitation();
            
          } else {
            handleRedirectAfterLoginSuccess();
          }
          

          if (authResult.additionalUserInfo && authResult.additionalUserInfo.providerId === EmailAuthProvider.PROVIDER_ID) {
            handleSignInLink(user?.email);
          }

          
          // handleRedirectAfterLoginSuccess();
          return false;
        },
        signInFailure: (error) => {
          enqueueSnackbar(error.message, { variant: "error" });
          return Promise.resolve();
        },
        uiShown: () => {
          document.getElementById("loader").style.display = "none";
        },
      },
      signInFlow: "popup",
      signInOptions: [
        GoogleAuthProvider.PROVIDER_ID,
        // {
        //   provider: EmailAuthProvider.PROVIDER_ID,
        //   signInMethod: EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
        //   requireDisplayName: true,
        //   disableSignUp: true,
        // },
      ],
      tosUrl: "<terms-of-service-url>",
      privacyPolicyUrl: "<your-privacy-policy-url>",
    };

  
    let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(authInstance);
    ui.start("#firebaseui-auth-container", uiConfig);

    const googleButtonInterval = setInterval(() => {
      const googleButton = document.querySelector('.firebaseui-idp-google');
      if (googleButton) {
        googleButton.style.backgroundColor = '#458ff1';
        googleButton.style.minHeight = '0px';
      }

      const googleSpan = document.querySelector('.firebaseui-idp-google .firebaseui-idp-text');
      if (googleSpan) {
        googleSpan.style.color = '#fff';
        clearInterval(googleButtonInterval);
      }


      const iconWrapper = document.querySelector('.firebaseui-idp-google .firebaseui-idp-icon-wrapper');
      if (iconWrapper) {
        iconWrapper.style.backgroundColor = '#fff';
        iconWrapper.style.width = '24px';
        iconWrapper.style.height = '24px';
        iconWrapper.style.margin = 'auto';
        iconWrapper.style.textAlign = 'center';
      }

      if (googleButton && googleSpan && iconWrapper) {
        clearInterval(googleButtonInterval);
      }


    }, 100);
  }, [authInstance, enqueueSnackbar, navigate, storedInvitationDetails]);

  const handleRedirectAfterLoginSuccess = () => {
    console.log("handleRedirectAfterLoginSuccess bbb");

    AuthenticationService.getProfile().then((res) => {
      let isSignatureSetup = res.data.data.profile.signatureSetup
      if (!isSignatureSetup) {
        navigate("/documents/create");
      } else {
        navigate("/dashboard");
      }
    })
  }

  const handleSignInLink = async () => {
    console.log("handleSignInLink bbb");

    if (!isSignInWithEmailLink(authInstance, url)) {
      console.log("isSignInWithEmailLink bbb");

      enqueueSnackbar("The link is invalid or expired. Please request a new one.", {
        variant: "error",
      });

      return;
    }

    const storedEmail = localStorage.getItem("emailForSignIn");
    console.log("storedEmail bbb", storedEmail);

    if (storedEmail ) {
      console.log("storedEmail bbb", storedEmail);
      completeSignIn(storedEmail);

    } else {
      setDialogOpen(true);
    }
  }

  const completeSignIn = async (email) => {
    console.log("completeSignIn bbb", email);

    try {
      const result = await signInWithEmailLink(auth, email, url);
      console.log("result bbb", result);

      localStorage.setItem("hasSignInUsingEmailAddress", "true");

      if (storedInvitationDetails) {
        handleAcceptInvitation();
      }
      
      enqueueSnackbar("Sign-in successful! Welcome back.", { variant: "success" });
      localStorage.removeItem("emailForSignIn");

    } catch (error) {
      enqueueSnackbar(`Sign-in failed: ${error.message}`, { variant: "error" });
    }
  }

  const handleEmailSubmit = () => {
    if (!email) {
      enqueueSnackbar("Please provide a valid email address.", { variant: "error" });
      return;
    }
    setDialogOpen(false);
    localStorage.setItem("emailForSignIn", email);
    completeSignIn(email);
  };


  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${require("../../../assets/images/background.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
        }}
      >
        <Box
          id="firebaseui-auth-container"
          sx={{
            backgroundColor: "#fff",
            width: "100%",
            maxWidth: 500,
            borderRadius: 2,
            py: 4,
            px: 3,
            textAlign: "center",
            boxShadow: 3,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <img src={superSignLogo} alt="Logo" style={{ maxWidth: 240, height: "auto" }} />
          </Box>
          <Typography variant="h4" fontWeight="medium" mb={1}>
            Get started today with <br /> 100 free tokens.
          </Typography>
          <Typography sx={{ color: "#FF6600", fontSize: 16 }}>
            No credit card required.
          </Typography>
        </Box>
  
        <Box id="loader" sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Rings color="#3498db" height={120} width={120} />
        </Box>
      </Box>
  
      {isDialogOpen && (
        <VerifyEmailDialog
          isDialogOpen={isDialogOpen}
          setDialogOpen={setDialogOpen}
          email={email}
          setEmail={setEmail}
          handleEmailSubmit={handleEmailSubmit}
        />
      )}
    </>
  );
  
};

export default FirebaseAuth;

